/**
 * Browser Detection Utility
 * Provides reliable browser identification with proper priority ordering
 */

export const BrowserType = {
	OPERA: 'Opera',
	EDGE: 'Edge',
	CHROME: 'Chrome',
	SAFARI: 'Safari',
	FIREFOX: 'Firefox',
	IE: 'IE',
	UNKNOWN: 'unknown',
};

/**
 * Detects browser type based on user agent string
 * Uses priority-based detection to handle overlapping user agent strings
 * 
 * @returns {string} Browser type from BrowserType enum
 */
export const getUserAgent = () => {
	const { userAgent } = navigator;
	
	// Order matters: Chrome contains "Safari", Edge contains "Chrome", etc.
	if (userAgent.indexOf('Opera') !== -1 || userAgent.indexOf('OPR') !== -1) {
		return BrowserType.OPERA;
	}
	
	if (userAgent.indexOf('Edg') !== -1) {
		return BrowserType.EDGE;
	}
	
	if (userAgent.indexOf('Chrome') !== -1) {
		return BrowserType.CHROME;
	}
	
	if (userAgent.indexOf('Safari') !== -1) {
		return BrowserType.SAFARI;
	}
	
	if (userAgent.indexOf('Firefox') !== -1) {
		return BrowserType.FIREFOX;
	}
	
	if (userAgent.indexOf('MSIE') !== -1 || !!document.documentMode) {
		return BrowserType.IE;
	}
	
	return BrowserType.UNKNOWN;
};

/**
 * Checks if current browser is Safari
 * @returns {boolean} True if Safari browser
 */
export const isSafari = () => getUserAgent() === BrowserType.SAFARI;

/**
 * Checks if current browser is Chrome
 * @returns {boolean} True if Chrome browser
 */
export const isChrome = () => getUserAgent() === BrowserType.CHROME;

/**
 * Checks if running in iframe context
 * @returns {boolean} True if in iframe
 */
export const isInIframe = () => window.self !== window.top; 